import {AppState} from '../../appState';

export function getCustomEmojiShortcodes(state: AppState) {
  return state.data.customEmojis.shortcodes;
}

export function getCustomEmojisRoute(state: AppState) {
  return state.data.customEmojis.route;
}
